import { z } from "zod";

import { fetchWithError } from "@nens/react-query-utils";
import { combineUrlAndParams } from "@nens/shared-utils";

import { lizardDateSchema } from "../dates";
import { TimeseriesEvent } from "../types";

const allTimeseriesEventsSchema = z.array(
  z.object({
    time: lizardDateSchema.nullable(),
    value: z.number().nullable().optional(),
  })
);

export async function fetchAllTimeseriesEvents(
  uuid: string,
  start: Date,
  end: Date,
  params: Record<string, string | number> = {}
) {
  const url = combineUrlAndParams(`/api/v4/timeseries/${uuid}/events/`, {
    page_size: 0,
    start: start.toISOString(),
    end: end.toISOString(),
    ...params,
  });

  const json = await fetchWithError(url);
  const results = allTimeseriesEventsSchema.parse(json);

  return results
    .filter((event) => event.time !== null)
    .map((event) => {
      return {
        time: event.time as Date,
        value: event.value,
      } as TimeseriesEvent;
    });
}
